import type { Doc } from "building-types/doc";
import type { ContentTemplateHandle, ContentTemplateInstanceHandle } from "building-types/handles/docEntityHandleTypes";
import type { ContentTemplateInstance } from "building-types/views/planSets";
import { docEntityGetChildrenFromTable } from "./docEntityGetChildrenFromTable";
import { docGetTableEntity } from "./docGetTableEntity";

export function docGetContentTemplateDependencies(
  doc: Doc,
  contentTemplate: ContentTemplateHandle,
  foundSoFar: Set<string> = new Set(),
): ContentTemplateHandle[] {
  const instances = docEntityGetChildrenFromTable(doc.contentTemplateInstances, contentTemplate.id);

  const allTemplates: ContentTemplateHandle[] = [];

  if (foundSoFar.has(contentTemplate.id)) {
    return [];
  }

  allTemplates.push(contentTemplate);
  foundSoFar.add(contentTemplate.id);

  const deps = Object.values(instances).map((x) => ({ type: "CONTENT_TEMPLATE", id: x.contentTemplateId }) as const);

  return allTemplates.concat(...deps.map((x) => docGetContentTemplateDependencies(doc, x, foundSoFar)));
}

export function docContentTemplateInstanceCanBeInsertedWithoutSelfReference(
  doc: Doc,
  contentTemplate: ContentTemplateHandle,
  parent: ContentTemplateHandle | ContentTemplateInstanceHandle,
): boolean {
  const deps = docGetContentTemplateDependencies(doc, contentTemplate);

  // the template instance cannot be placed inside of a template that it depends on
  if (parent.type === "CONTENT_TEMPLATE") {
    if (deps.find((x) => x.type === parent.type && x.id === parent.id)) {
      return false;
    }
  } else if (parent.type === "CONTENT_TEMPLATE_INSTANCE") {
    const template = docGetTableEntity(doc, parent) as ContentTemplateInstance;

    if (deps.find((x) => x.id === template.contentTemplateId)) {
      return false;
    }
  }

  return true;
}
